import {requestCommon} from '../libs/axios'


export const getCaseShareDetail = (params) => requestCommon.post('/info/caseSourceV2/shareInfo', params) // 获取分享后的案源信息
export const getArticleShareDetail = (params) => requestCommon.post('/info/caseSourceV2/shareArticleInfo', params) // 文章信息
export const getShareGoodNewsShareDetail = (params) => requestCommon.post('/info/caseSourceV2/shareGoodNewsInfo', params) // 成单喜报
export const lawyerCollaboration = (params) => requestCommon.post('/paralegal/lawyerCollaboration/detail', params) // 协作详情（微信分享页面使用）
export const redPacketMoment = (params) => requestCommon.post('/paralegal/goodNewsLawyerUpload/redPacketMoment', params) // 协作详情（微信分享页面使用）
export const lawsuitCaseInfos = (params) => requestCommon.post('/info/lawsuitCase/shareInfo', params) // 查询分享官司比价分享信息（微信分享页面使用）

